// Funzione per formattare i prezzi con due decimali quando necessario
const formatPrice = (price) => {
  // Se il prezzo è un numero intero, lo mostra senza decimali
  if (Number.isInteger(price)) {
    return price.toString();
  }
  // Se è decimale, mostra sempre due decimali
  return price.toFixed(2);
};

// Esempi di formattazione:
// formatPrice(9) → "9" (numero intero, nessun decimale)
// formatPrice(4.5) → "4.50" (numero decimale, due decimali)
// formatPrice(13.75) → "13.75" (numero decimale, due decimali)

const calculateTax = (adultCount, startDate, endDate) => {
  console.log("=== CALCOLO TASSA DI SOGGIORNO ===");
  console.log("adultCount:", adultCount);
  const oneDay = 24 * 60 * 60 * 1000; // Ore * Minuti * Secondi * Millisecondi
  const start = new Date(startDate);
  const end = new Date(endDate);
  const nights = Math.round(Math.abs((end - start) / oneDay)); // Calcolo delle notti
  const peopleCount = adultCount; // Solo gli adulti pagano la tassa di soggiorno
  console.log("peopleCount (solo adulti):", peopleCount);
  console.log("nights:", nights);
  const tax = peopleCount * nights * 5.5; // Tassa di 4.50€ per adulto per notte
  console.log("tax calcolata:", tax);
  console.log("================================");
  return tax;
};

// Esporta sia la funzione originale che quella formattata
export const calculateTaxFormatted = (adultCount, startDate, endDate) => {
  const tax = calculateTax(adultCount, startDate, endDate);
  return formatPrice(tax);
};

export default calculateTax;
